import React from "react";

const Weather = props => (
    <div className="weather__info">
        {props.city &&
            props.country && (
                <p className="weather__key">
                    Location:{" "}
                    <span className="weather__value">
                        {props.city}, {props.country}{" "}
                        {props.icon && (
                            <img
                                src={
                                    "http://openweathermap.org/img/w/" +
                                    props.icon
                                }
                                alt={props.description}
                            />
                        )}
                    </span>
                </p>
            )}
        {props.temperature && (
            <p className="weather__key">
                Tempreture:{" "}
                <span className="weather__value">{props.temperature}</span>
            </p>
        )}
        {props.humidity && (
            <p className="weather__key">
                Humidity:{" "}
                <span className="weather__value">{props.humidity}</span>
            </p>
        )}
        {props.description && (
            <p className="weather__key">
                Description:{" "}
                <span className="weather__value">{props.description}</span>
            </p>
        )}
        {props.error && <p className="weather__error">{props.error}</p>}
    </div>
);

export default Weather;
